import { FC } from "react";
import images from "../../../images";
import { getErrorMessage } from "../../../utils/errors";
import Image from "next/image";
import { ErrorAlertWrapper, ErrorIdWrapper } from "./ErrorAlert.styled";

type ErrorAlertProps = {
  /**
   * If it's an AxiosError, the component prioritizes displaying the error message
   * explicitly returned by the backend (if available).
   * If it's an AlertError thrown inside the frontend, this will be prioritised next.
   * If neither exists, it will use the provided `fallbackErrorMessage`.
   * If `fallbackErrorMessage` is also not provided, a generic error message will be shown.
   */
  error?: Error & { errorId?: string };

  /**
   * See the `error` field for an explanation of why this is useful.
   */
  fallbackErrorMessage?: string;
};

const ErrorAlert: FC<ErrorAlertProps> = ({ error, fallbackErrorMessage }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errorId = (error as any)?.response?.data?.errorId ?? error?.errorId;
  return (
    <ErrorIdWrapper>
      <ErrorAlertWrapper>
        <Image alt="" src={images.cross} width={48} height={48} />
        <div>{getErrorMessage(error, fallbackErrorMessage)}</div>
      </ErrorAlertWrapper>
      {errorId && (
        <div>
          If you would like to learn more about the error, contact us using the error ID: <code>{errorId}</code>.
        </div>
      )}
    </ErrorIdWrapper>
  );
};

export default ErrorAlert;
